/* eslint-disable class-methods-use-this */
import axios, { AxiosResponse } from 'axios'

interface ConfigNameFileContents {
  runtimeConfigName: string
}

export default class RuntimeConfigNameRetriever {
  public async retrieveConfigName(): Promise<string> {
    const response = await this.makeRequest()
    const runtimeConfigName = RuntimeConfigNameRetriever.obtainConfigNameFromResponse(response)
    return runtimeConfigName
  }

  private async makeRequest(): Promise<AxiosResponse<ConfigNameFileContents>> {
    try {
      return await axios.get<ConfigNameFileContents>('/runtime-config-name.json')
    } catch (error) {
      throw new Error(`An error occured while fetching the file with runtime configuration name.`)
    }
  }

  private static obtainConfigNameFromResponse(
    response: AxiosResponse<ConfigNameFileContents>,
  ): string {
    const payload = response.data
    if (
      !payload ||
      !payload.runtimeConfigName ||
      !RuntimeConfigNameRetriever.isString(payload.runtimeConfigName)
    ) {
      throw RuntimeConfigNameRetriever.createCannotGetConfigNameError()
    }
    return payload.runtimeConfigName
  }

  private static isString(value: unknown): boolean {
    return typeof value === 'string' || value instanceof String
  }

  private static createCannotGetConfigNameError() {
    return new Error(`Cannot obtain runtime configuration name.`)
  }
}
